// ============================================================
// GIVEASY OFFER WIDGET
// Drop this into your Shopify theme:
//   1. Go to Shopify Admin → Online Store → Themes → Edit code
//   2. Open assets/ → Add a new asset → paste this file as offer-widget.js
//   3. In your product.liquid (or product-form.liquid), add:
//      {{ 'offer-widget.js' | asset_url | script_tag }}
//      <div id="giveasy-offer-root"
//           data-product-id="{{ product.id }}"
//           data-variant-id="{{ product.selected_or_first_available_variant.id }}"
//           data-product-title="{{ product.title | escape }}"
//           data-listed-price="{{ product.price }}"
//           data-image="{{ product.featured_image | img_url: '400x400' }}">
//      </div>
// ============================================================

(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────
  const SUPABASE_FUNCTION_URL = 'https://heaoxwmpxycxxsgeewfk.supabase.co/functions/v1/create-offer';
  // Replace YOUR_PROJECT with your actual Supabase project ref

  // ── Styles (injected once) ─────────────────────────────────
  const CSS = `
    #gw-btn-offer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      padding: 15px;
      background: #1E1E1E;
      color: #F2F2F2;
      border: 1.5px solid #2A2A2A;
      border-radius: 14px;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      font-family: inherit;
      margin-top: 10px;
      transition: border-color 0.2s, color 0.2s;
    }
    #gw-btn-offer:hover { border-color: #00E5A0; color: #00E5A0; }

    #gw-backdrop {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.7);
      z-index: 9998;
      backdrop-filter: blur(4px);
    }
    #gw-backdrop.open { display: block; }

    #gw-sheet {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      max-width: 480px;
      margin: 0 auto;
      background: #141414;
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
      border: 1px solid #2A2A2A;
      border-bottom: none;
      z-index: 9999;
      padding: 0 16px 40px;
      transform: translateY(100%);
      transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1);
      font-family: 'Space Grotesk', -apple-system, sans-serif;
      color: #F2F2F2;
    }
    #gw-sheet.open { transform: translateY(0); }

    .gw-handle {
      width: 36px; height: 4px;
      background: #2A2A2A;
      border-radius: 2px;
      margin: 12px auto 20px;
    }
    .gw-title { font-size: 20px; font-weight: 800; margin-bottom: 6px; }
    .gw-sub { font-size: 13px; color: #888; margin-bottom: 20px; line-height: 1.4; }

    .gw-product-strip {
      display: flex; gap: 12px; align-items: center;
      background: #1E1E1E; border: 1px solid #2A2A2A;
      border-radius: 14px; padding: 12px; margin-bottom: 20px;
    }
    .gw-thumb {
      width: 52px; height: 52px; border-radius: 10px;
      object-fit: cover; background: #282828; flex-shrink: 0;
    }
    .gw-pname { font-size: 13px; font-weight: 600; margin-bottom: 4px; }
    .gw-pprice { font-size: 15px; font-weight: 700; }

    .gw-label {
      font-size: 11px; font-weight: 600; color: #888;
      text-transform: uppercase; letter-spacing: 0.5px;
      display: block; margin-bottom: 8px;
    }
    .gw-field { margin-bottom: 16px; }

    .gw-offer-wrap {
      display: flex; align-items: center;
      background: #1E1E1E; border: 1.5px solid #2A2A2A;
      border-radius: 14px; overflow: hidden;
      transition: border-color 0.2s;
    }
    .gw-offer-wrap.focused { border-color: #00E5A0; }
    .gw-prefix { padding: 14px 0 14px 16px; font-size: 20px; font-weight: 700; color: #888; }
    .gw-offer-wrap input {
      background: none; border: none; outline: none;
      color: #F2F2F2; font-family: inherit;
      font-size: 22px; font-weight: 700;
      padding: 14px 14px 14px 6px; flex: 1; min-width: 0;
    }
    .gw-offer-wrap input::placeholder { color: #444; font-size: 18px; }

    .gw-chips { display: flex; gap: 8px; margin-top: 10px; flex-wrap: wrap; }
    .gw-chip {
      background: #1E1E1E; border: 1px solid #2A2A2A;
      border-radius: 100px; padding: 6px 12px;
      font-size: 12px; font-weight: 600; cursor: pointer;
      transition: all 0.15s; color: #F2F2F2; font-family: inherit;
    }
    .gw-chip:hover, .gw-chip.sel { border-color: #00E5A0; color: #00E5A0; background: rgba(0,229,160,0.1); }
    .gw-hint { font-size: 12px; color: #888; margin-top: 8px; }
    .gw-hint.good { color: #00E5A0; }
    .gw-hint.low  { color: #FFB800; }
    .gw-hint.bad  { color: #FF4040; }

    .gw-pin-row { display: flex; gap: 10px; }
    .gw-pin-row input {
      flex: 1; background: #1E1E1E; border: 1.5px solid #2A2A2A;
      border-radius: 14px; outline: none; color: #F2F2F2;
      font-family: inherit; font-size: 18px; font-weight: 600;
      padding: 13px 16px; letter-spacing: 2px;
      transition: border-color 0.2s;
    }
    .gw-pin-row input:focus { border-color: #00E5A0; }
    .gw-pin-row input::placeholder { letter-spacing: 0; font-weight: 400; font-size: 14px; color: #444; }
    .gw-locate-btn {
      background: #1E1E1E; border: 1.5px solid #2A2A2A;
      border-radius: 14px; padding: 0 15px;
      font-size: 20px; cursor: pointer; display: flex;
      align-items: center; justify-content: center; flex-shrink: 0;
    }

    .gw-pin-status { font-size: 12px; font-weight: 600; margin-top: 8px; display: none; }
    .gw-pin-status.ok { color: #00E5A0; display: flex; gap: 5px; }
    .gw-pin-status.err { color: #FF4040; display: flex; gap: 5px; }

    .gw-name-row { display: flex; gap: 10px; }
    .gw-name-row input, .gw-phone-input {
      flex: 1; background: #1E1E1E; border: 1.5px solid #2A2A2A;
      border-radius: 14px; outline: none; color: #F2F2F2;
      font-family: inherit; font-size: 15px; font-weight: 500;
      padding: 13px 16px; transition: border-color 0.2s;
    }
    .gw-name-row input:focus, .gw-phone-input:focus { border-color: #00E5A0; }
    .gw-name-row input::placeholder, .gw-phone-input::placeholder { color: #444; font-weight: 400; }

    .gw-info {
      display: flex; gap: 10px; align-items: flex-start;
      background: #1E1E1E; border: 1px solid #2A2A2A;
      border-radius: 12px; padding: 12px 14px; margin-bottom: 16px;
      font-size: 12px; color: #888; line-height: 1.5;
    }

    .gw-submit {
      width: 100%; background: #00E5A0; color: #0A0A0A;
      border: none; border-radius: 14px; padding: 16px;
      font-family: inherit; font-size: 16px; font-weight: 700;
      cursor: pointer; display: flex; align-items: center;
      justify-content: center; gap: 8px; transition: opacity 0.2s;
    }
    .gw-submit:disabled { opacity: 0.4; cursor: not-allowed; }
    .gw-submit.loading { opacity: 0.7; }

    .gw-success {
      text-align: center; padding: 20px 0;
    }
    .gw-success-icon {
      width: 72px; height: 72px; background: rgba(0,229,160,0.12);
      border: 2px solid #00E5A0; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 36px; margin: 0 auto 20px;
      animation: gwPop 0.4s cubic-bezier(0.34,1.56,0.64,1) both;
    }
    @keyframes gwPop { from { transform: scale(0); opacity: 0; } to { transform: scale(1); opacity: 1; } }
    .gw-success h2 { font-size: 22px; font-weight: 800; margin-bottom: 8px; }
    .gw-success h2 span { color: #00E5A0; }
    .gw-success p { font-size: 14px; color: #888; line-height: 1.6; margin-bottom: 20px; }
    .gw-sms-note {
      background: rgba(37,211,102,0.08); border: 1px solid rgba(37,211,102,0.25);
      border-radius: 12px; padding: 12px 14px;
      font-size: 13px; color: #888; text-align: left; line-height: 1.5;
    }
    .gw-sms-note strong { color: #25D366; }
  `;

  // ── Init ───────────────────────────────────────────────────
  function init() {
    const root = document.getElementById('giveasy-offer-root');
    if (!root) return;

    injectStyles();

    const productId    = root.dataset.productId;
    const variantId    = root.dataset.variantId;
    const productTitle = root.dataset.productTitle;
    const listedPrice  = parseInt(root.dataset.listedPrice || '0'); // Shopify gives cents/paise
    const imageUrl     = root.dataset.image || '';
    const sellerPhone  = root.dataset.sellerPhone || '';

    // Insert "Make Offer" button after the add-to-cart button
    const btn = document.createElement('button');
    btn.id = 'gw-btn-offer';
    btn.innerHTML = '✋ Make Offer';
    root.appendChild(btn);

    // Create backdrop + sheet
    const backdrop = document.createElement('div');
    backdrop.id = 'gw-backdrop';
    document.body.appendChild(backdrop);

    const sheet = document.createElement('div');
    sheet.id = 'gw-sheet';
    sheet.innerHTML = buildSheetHTML(productTitle, listedPrice, imageUrl);
    document.body.appendChild(sheet);

    // ── Event listeners ──────────────────────────────────────
    btn.addEventListener('click', () => open());
    backdrop.addEventListener('click', () => close());

    function open() {
      backdrop.classList.add('open');
      sheet.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      backdrop.classList.remove('open');
      sheet.classList.remove('open');
      document.body.style.overflow = '';
    }

    // Offer input focus
    const offerWrap = sheet.querySelector('.gw-offer-wrap');
    const offerInput = sheet.querySelector('#gw-offer-input');
    offerInput?.addEventListener('focus', () => offerWrap?.classList.add('focused'));
    offerInput?.addEventListener('blur',  () => offerWrap?.classList.remove('focused'));
    offerInput?.addEventListener('input', (e) => updateHint(e.target.value, listedPrice));

    // Quick chips
    sheet.querySelectorAll('.gw-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const val = chip.dataset.amount;
        if (offerInput) offerInput.value = val;
        sheet.querySelectorAll('.gw-chip').forEach(c => c.classList.remove('sel'));
        chip.classList.add('sel');
        updateHint(val, listedPrice);
      });
    });

    // Pincode validation
    const pinInput = sheet.querySelector('#gw-pin-input');
    let pinTimer;
    pinInput?.addEventListener('input', (e) => {
      clearTimeout(pinTimer);
      const val = e.target.value;
      if (val.length === 6) {
        pinTimer = setTimeout(() => validatePin(val, sheet), 800);
      } else {
        sheet.querySelector('#gw-pin-status').className = 'gw-pin-status';
      }
    });

    // Submit
    sheet.querySelector('#gw-submit-btn')?.addEventListener('click', () => submitOffer({
      productId, variantId, productTitle, listedPrice, imageUrl, sellerPhone, sheet, close
    }));
  }

  // ── Sheet HTML ─────────────────────────────────────────────
  function buildSheetHTML(title, listedPrice, imageUrl) {
    const priceRs = (listedPrice / 100).toLocaleString('en-IN');
    // Suggest chips at 90%, 85%, 80% of listed
    const chips = [0.90, 0.85, 0.80].map(pct => {
      const amt = Math.round(listedPrice * pct / 100) * 100;
      const rs = (amt / 100).toLocaleString('en-IN');
      return `<button class="gw-chip" data-amount="${amt / 100}">₹${rs}</button>`;
    });

    return `
      <div class="gw-handle"></div>
      <div id="gw-form-state">
        <div class="gw-title">Name Your Price</div>
        <div class="gw-sub">Goes directly to the seller. They usually respond within a few hours.</div>

        <div class="gw-product-strip">
          ${imageUrl ? `<img class="gw-thumb" src="${imageUrl}" alt="">` : '<div class="gw-thumb"></div>'}
          <div>
            <div class="gw-pname">${title}</div>
            <div class="gw-pprice">₹${priceRs}</div>
          </div>
        </div>

        <div class="gw-field">
          <label class="gw-label">Your Offer</label>
          <div class="gw-offer-wrap">
            <span class="gw-prefix">₹</span>
            <input id="gw-offer-input" type="number" placeholder="0" inputmode="numeric">
          </div>
          <div class="gw-chips">${chips.join('')}</div>
          <div class="gw-hint" id="gw-offer-hint">Listed at ₹${priceRs} — sellers typically accept 10–15% below</div>
        </div>

        <div class="gw-field">
          <label class="gw-label">Your Name</label>
          <div class="gw-name-row">
            <input id="gw-buyer-name" type="text" placeholder="First name">
          </div>
        </div>

        <div class="gw-field">
          <label class="gw-label">Mobile Number</label>
          <input class="gw-phone-input" id="gw-buyer-phone" type="tel" placeholder="10-digit number" maxlength="10" inputmode="numeric">
        </div>

        <div class="gw-field">
          <label class="gw-label">Delivery Pincode</label>
          <div class="gw-pin-row">
            <input id="gw-pin-input" type="number" placeholder="6-digit pincode" maxlength="6" inputmode="numeric">
            <button class="gw-locate-btn" onclick="navigator.geolocation && navigator.geolocation.getCurrentPosition(function(){})">📍</button>
          </div>
          <div class="gw-pin-status" id="gw-pin-status"></div>
        </div>

        <div class="gw-info">
          <span>💬</span>
          <span>Seller is notified via WhatsApp instantly. You get a WhatsApp message when they respond — no app needed.</span>
        </div>

        <button class="gw-submit" id="gw-submit-btn">✋ Send Offer to Seller</button>
      </div>

      <div id="gw-success-state" class="gw-success" style="display:none">
        <div class="gw-success-icon">✓</div>
        <h2>Offer <span>Sent!</span></h2>
        <p>Your offer is with the seller. You'll get a WhatsApp message the moment they respond.</p>
        <div class="gw-sms-note">
          📱 Seller notified via <strong>WhatsApp</strong>. You'll hear back via WhatsApp too — keep your phone nearby.
        </div>
      </div>
    `;
  }

  // ── Offer hint ─────────────────────────────────────────────
  function updateHint(val, listedPrice) {
    const hint = document.getElementById('gw-offer-hint');
    if (!hint) return;
    const v = parseFloat(val);
    const listed = listedPrice / 100;
    if (!v || v <= 0) {
      hint.textContent = `Listed at ₹${listed.toLocaleString('en-IN')} — sellers typically accept 10–15% below`;
      hint.className = 'gw-hint';
      return;
    }
    const pct = Math.round((1 - v / listed) * 100);
    if (v > listed) {
      hint.textContent = `Above asking price — seller will accept immediately!`;
      hint.className = 'gw-hint good';
    } else if (pct <= 15) {
      hint.textContent = `${pct}% below asking — strong offer ✓`;
      hint.className = 'gw-hint good';
    } else if (pct <= 25) {
      hint.textContent = `${pct}% below — seller may counter`;
      hint.className = 'gw-hint low';
    } else {
      hint.textContent = `${pct}% below — quite low, consider going higher`;
      hint.className = 'gw-hint bad';
    }
  }

  // ── Pin validation ─────────────────────────────────────────
  function validatePin(pin, sheet) {
    const status = sheet.querySelector('#gw-pin-status');
    // Simple rule: pincodes starting with 1-8 are serviceable (expand as needed)
    const first = parseInt(pin[0]);
    if (first >= 1 && first <= 8) {
      status.className = 'gw-pin-status ok';
      status.textContent = '✓ Delivery available to ' + pin;
    } else {
      status.className = 'gw-pin-status err';
      status.textContent = '✗ We don\'t deliver here yet — contact us';
    }
  }

  // ── Submit ─────────────────────────────────────────────────
  async function submitOffer({ productId, variantId, productTitle, listedPrice, imageUrl, sellerPhone, sheet, close }) {
    const offerAmt  = parseFloat(document.getElementById('gw-offer-input')?.value || '0');
    const buyerName = document.getElementById('gw-buyer-name')?.value?.trim();
    const buyerPhone = document.getElementById('gw-buyer-phone')?.value?.trim();
    const pincode   = document.getElementById('gw-pin-input')?.value?.trim();

    if (!offerAmt || offerAmt <= 0) { alert('Please enter your offer amount'); return; }
    if (!buyerPhone || buyerPhone.length !== 10) { alert('Please enter a valid 10-digit mobile number'); return; }
    if (!pincode || pincode.length !== 6) { alert('Please enter a valid 6-digit pincode'); return; }

    const btn = document.getElementById('gw-submit-btn');
    btn.textContent = 'Sending…';
    btn.disabled = true;
    btn.classList.add('loading');

    try {
      const res = await fetch(SUPABASE_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shopify_product_id:  String(productId),
          shopify_variant_id:  String(variantId),
          product_title:       productTitle,
          product_image_url:   imageUrl,
          listed_price:        listedPrice,        // paise
          seller_phone:        sellerPhone || null, // from Liquid data attribute
          buyer_name:          buyerName || null,
          buyer_phone:         buyerPhone,
          buyer_pincode:       pincode,
          offer_amount:        Math.round(offerAmt * 100),  // convert ₹ → paise
        }),
      });

      const data = await res.json();
      if (data.success) {
        sheet.querySelector('#gw-form-state').style.display = 'none';
        sheet.querySelector('#gw-success-state').style.display = 'block';
      } else {
        alert('Error: ' + (data.error || 'Something went wrong'));
        btn.textContent = '✋ Send Offer to Seller';
        btn.disabled = false;
        btn.classList.remove('loading');
      }
    } catch (err) {
      alert('Network error. Please try again.');
      btn.textContent = '✋ Send Offer to Seller';
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  }

  // ── Inject styles ──────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('gw-styles')) return;
    const style = document.createElement('style');
    style.id = 'gw-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  // ── Run ────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();